import * as React from 'react';
import CircularProgress, {
  CircularProgressProps,
} from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function CircularProgressWithLabel(
  props: CircularProgressProps & { value: number } & { message?: string },
) {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant="determinate" {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          color="text.secondary"
        >{`${props.value}%`}{props.message}</Typography>
      </Box>
    </Box>
  );
}

export default function CircularStatic(props: any) {
  const [progress, setProgress] = React.useState(props.value);
  React.useEffect(() => {
    setProgress(props.value)
  }, [props.value]);

  return <CircularProgressWithLabel value={progress} />;
}